import { Menu, Transition } from '@headlessui/react'
import { SelectorIcon } from '@heroicons/react/outline'
import classNames from 'classnames'
import { Fragment } from 'react'
import 'antd/es/tooltip/style/css'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { some } from 'lodash'
import { isPartnerDashboardUser } from 'lib/auth/dashboardRole'

const BottomMenu = ({ workspaces, user, handleLogout, currentWorkspace, openChangePasswordModal }) => {
  const history = useHistory()
  const { t, i18n } = useTranslation()
  const isRTL = i18n.language === 'ar'
  const isCompanyRole = some(user?.roles, { type: 'company' })
  const isPartnerRole = isPartnerDashboardUser(user)
  const showCompanyEcommerceLink = isCompanyRole && (user?.canManageBranding || user?.canManageDns)
  const showPartnerSettingsLink = isPartnerRole

  return (
    <Menu as="div" className="relative block w-full text-left">
      <div>
        <Menu.Button className="group w-full bg-white px-2.5 pt-2.5 pb-0 text-left text-sm font-medium text-slate-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-dark-500/25">
          <span dir={isRTL ? 'rtl' : 'ltr'} className="flex w-full min-w-0 items-center justify-between gap-2">
            <span className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
              <img className="h-9 w-9 flex-shrink-0 rounded-full bg-slate-200 object-cover ring-2 ring-white shadow-sm" src={user.userProfile?.profile} alt="" />
              <span className="inline-flex min-w-0 flex-1 flex-col items-stretch overflow-hidden text-start">
                <span className="text-[11px] font-medium uppercase tracking-wide text-slate-500">{t('sidebar.admin')}</span>
                <span className="truncate text-sm font-semibold leading-tight text-slate-800">{user.displayName}</span>
              </span>
            </span>
            <SelectorIcon className="h-5 w-5 flex-shrink-0 text-slate-400 transition-colors group-hover:text-slate-600" aria-hidden="true" />
          </span>
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          style={{ zIndex: 1000 }}
          className="absolute -top-2 left-0 right-0 mt-1 origin-bottom -translate-y-full border border-slate-200/90 bg-white py-1 shadow-lg shadow-slate-900/5 ring-1 ring-slate-900/5 focus:outline-none"
        >
          <div className="py-1">
            <Menu.Item onClick={() => history.push('/profile')}>
              {({ active }) => (
                <span className={classNames(active ? 'cursor-pointer bg-slate-50 text-slate-900' : 'text-slate-700', 'block px-4 py-2 text-sm')}>
                  {t('sidebar.profileSetting')}
                </span>
              )}
            </Menu.Item>
            <Menu.Item onClick={() => openChangePasswordModal()}>
              {({ active }) => (
                <span className={classNames(active ? 'cursor-pointer bg-slate-50 text-slate-900' : 'text-slate-700', 'block px-4 py-2 text-sm')}>
                  {t('sidebar.changePassword')}
                </span>
              )}
            </Menu.Item>
            {showCompanyEcommerceLink ? (
              <Menu.Item onClick={() => history.push('/company/ecommerce')}>
                {({ active }) => (
                  <span className={classNames(active ? 'cursor-pointer bg-slate-50 text-slate-900' : 'text-slate-700', 'block px-4 py-2 text-sm')}>
                    {t('sidebar.companyEcommerce')}
                  </span>
                )}
              </Menu.Item>
            ) : null}
            {showPartnerSettingsLink ? (
              <Menu.Item onClick={() => history.push('/partner/settings')}>
                {({ active }) => (
                  <span className={classNames(active ? 'cursor-pointer bg-slate-50 text-slate-900' : 'text-slate-700', 'block px-4 py-2 text-sm')}>
                    {t('sidebar.partnerSettings')}
                  </span>
                )}
              </Menu.Item>
            ) : null}
          </div>
          <div className="border-t border-slate-100 py-1">
            <Menu.Item onClick={handleLogout}>
              {({ active }) => (
                <span className={classNames(active ? 'cursor-pointer bg-rose-50 text-rose-900' : 'text-slate-700', 'block px-4 py-2 text-sm')}>{t('sidebar.logout')}</span>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default BottomMenu
